<template>
  <BaseSnackbar
    :icon="messageStore.snackbar.icon"
    :icon-color="
      messageStore.snackbar.color === 'success'
        ? 'success'
        : messageStore.snackbar.color
    "
    :model-value="messageStore.snackbar.active"
    test-id="sign-success"
    @update:model-value="!$event && messageStore.hideMessage()"
  >
    <!-- KEY -->
    <span v-if="messageStore.snackbar.key">
      {{ i18n.t(messageStore.snackbar.key) }}
    </span>
    <!-- /KEY -->

    <!-- TEXT -->
    <span v-if="messageStore.snackbar.text">
      {{ String(messageStore.snackbar.text) }}
    </span>
    <!-- /TEXT -->

    <!-- CONTEXTUAL ACTIONS -->
    <template #actions>
      <template
        v-for="(action, index) in messageStore.snackbar.actions"
        :key="index"
      >
        <div class="d-flex flex-row align-center justify-center">
          <a
            v-if="action.text"
            class="action-text"
            :href="action.href"
            :style="`color: ${action.color}`"
            target="_blank"
          >
            {{ i18n.t(action.text) }}
          </a>
          <v-icon v-if="action.separator" class="pipe" icon="fat fa-pipe" />
        </div>
      </template>
    </template>
    <!-- /CONTEXTUAL ACTIONS -->
  </BaseSnackbar>
</template>

<script setup lang="ts">
import BaseSnackbar from '@/components/snackbar/BaseSnackbar.vue';
import { useMessageStore } from '@/stores/message.ts';
import { useI18n } from 'vue-i18n';

const messageStore = useMessageStore();
const i18n = useI18n();
</script>
<style lang="scss" scoped>
.pipe {
  margin: 0;
  color: rgba(0, 0, 0, 0.15);
}

.action-text {
  margin: 0 12px;
  text-decoration: none;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.004em;
}
</style>
